import { Grid2 } from '@mui/material';
import React from 'react';
import PlanEquationStyle from "./PlanEquationStyle.module.scss";
function PlanEquation(props) {
  const {used,total}=props;
  return(
    <Grid2 container >
        <Grid2 className={PlanEquationStyle.usedStyle}>{used}</Grid2>
        <Grid2 className={PlanEquationStyle.totalStyle}>/</Grid2>
        <Grid2 className={PlanEquationStyle.totalStyle}>{total}</Grid2>
    </Grid2>
  );
}

export default PlanEquation;
